import createIntlWithLocale from 'src/internal/createIntlWithLocale';

import type {IAnalytics, IReports} from '@sail/observability';
import type {
  DateTimeStyle,
  InputDate,
  StaticDateTimeStyle,
} from 'src/internal/date-formatter/types';
import type {IntlConfig, Locale} from 'src/types';

function getYear(
  date: InputDate,
  locale: Locale,
  timeZone: string,
  config: IntlConfig,
  reports: IReports,
  analytics: IAnalytics,
): string {
  const intl = createIntlWithLocale(locale, config, reports, analytics);

  return intl.formatDate(date, {timeZone, year: 'numeric'});
}

const regexYear = /(-year)\?/;

export default function resolveStyle(
  date: InputDate,
  options: {
    locale: Locale;
    timeZone: string;
    style: DateTimeStyle;
  },
  config: IntlConfig,
  reports: IReports,
  analytics: IAnalytics,
): StaticDateTimeStyle {
  const {style} = options;
  let resultingStyle: string = style;

  if (regexYear.test(style)) {
    const givenDateYear = getYear(
      date,
      options.locale,
      options.timeZone,
      config,
      reports,
      analytics,
    );
    const currentYear = getYear(
      Date.now(),
      options.locale,
      options.timeZone,
      config,
      reports,
      analytics,
    );

    if (givenDateYear && currentYear && givenDateYear === currentYear) {
      resultingStyle = resultingStyle.replace(regexYear, '');
    } else {
      resultingStyle = resultingStyle.replace(regexYear, '$1');
    }
  }

  return resultingStyle as StaticDateTimeStyle;
}
